<div class="terms-container">
  <div class="terms-header">ArogyaLine: TERMS OF USE</div>
  <div>
    <p>
      Welcome to ArogyaLine.This document is an electronic record in terms of Information Technology Act, 2000 and
      published in accordance with the provisions of Rule 3 ) of the Information Technology (Intermediaries guidelines)
      Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage
      of ArogyaLine platform - www.arogyaline.com (hereinafter referred to as "Platform")
    </p>

    <p>
      The Platform is owned by RKB Software, having its registered office at Shivani Building,
      Sanjay Park, Lane number 6, Airport Road, Pune, Maharashtra : 411032, India.
    </p>

    <p>
      Your use of the ArogyaLine and services and tools are governed by the following terms and conditions
      ("<strong>Terms of
        Use</strong>") as applicable to the ArogyaLine including the applicable policies which are incorporated herein
      by way of
      reference. By mere use of the ArogyaLine, You shall be contracting with RKB Software, the
      owner of the Platform. These terms and conditions including the policies constitute Your binding obligations, with
      ArogyaLine.
    </p>

    <p>
      For the purpose of these Terms of Use, wherever the context so requires "<strong>You</strong>" or
      "<strong>User</strong>" shall mean any natural or
      legal person who has agreed to provide data while registering on the Platform as
      Registered User. The term
      "<strong>ArogyaLine</strong>","<strong>We</strong>","<strong>Us</strong>","<strong>Our</strong>" shall mean
      RKB Software and its
      affiliates.
    </p>

    <p>
      When You use any of the services provided by Us through the Platform, including but not limited to, (e.g.
      Appointment
      Booking, Clinic Search, etc), You will be subject to the rules, guidelines, policies, terms, and conditions
      applicable
      to such service, and they shall be deemed to be incorporated into this Terms of Use and shall be considered as
      part
      and parcel of this Terms of Use. We reserve the right, at Our sole discretion, to change, modify, add or remove
      portions of these Terms of Use, at any time without any prior written notice to You. You shall ensure to review
      these Terms of Use periodically for updates/changes. Your continued use of the Platform following the posting of
      changes will mean that You accept and agree to the revisions. As long as You comply with these Terms of Use, We
      grant You a personal, non-exclusive, non-transferable, limited privilege to enter and use the Platform. By
      impliedly
      or expressly accepting these Terms of Use, You also accept and agree to be bound by ArogyaLine Policies including
      but not limited to Privacy Policy as amended from time to time.
    </p>

    <div class="section-title">
      1. User Account, Password, and Security:
      <p>
        If You use the Platform, You shall be responsible for maintaining the confidentiality of your Display Name and
        Password and You shall be responsible for all activities that occur under your Display Name and Password. You
        agree
        that if You provide any information that is untrue, inaccurate, not current or incomplete or not in accordance
        with
        this Terms of Use, We shall have the right to indefinitely suspend or terminate or block Your access on the
        Platform.
      </p>
      <p>
        If there is reason to believe that there is likely to be a breach of security or misuse of Your account, We may
        request You to change the password or we may suspend Your account without any liability to ArogyaLine, for such
        period of time as we deem appropriate in the circumstances. We shall not be liable for any loss or damage
        arising
        from Your failure to comply with this provision.
      </p>
      <p>
        In the event of a device being associated with multiple logins or sign ups, as a measure to enhance customer's
        security and privacy as well as safeguarding your sensitive information for any potential risks, ArogyaLine
        sometimes consider moderating users and their association with devices while using the ArogyaLine app or
        website.
      </p>
      <p>
        Your mobile phone number & Email address is treated as Your primary identifier on the Platform. It is your
        responsibility to
        ensure
        that Your mobile phone number and your email address is up to date on the Platform at all times. You agree to
        notify
        Us promptly if your mobile phone number or e-mail address changes by updating the same on the Platform through
        an
        OTP verification. You agree that ArogyaLine shall not be liable or responsible for the activities or
        consequences of
        use or misuse of any information that occurs under your Account in cases, including, where You have failed to
        update
        Your revised mobile phone number and/or e-mail address on the Platform. You agree to immediately notify
        ArogyaLine
        of any unauthorized use/breach of your password or account.
      </p>
      <p>
        If You share or allow others to have access to Your account on the Platform ("Account"), by creating separate
        profiles under Your Account, or otherwise, they will be able to view and access Your Account information, You
        shall
        be solely liable and responsible for all the activities undertaken under Your Account, and any consequences
        therefrom.
      </p>
      <p>
        If You have not accessed Platform for a period of 2 (two) Years, Your data (including transactional data) will
        be
        deleted from Our record and You will not be able to access such data.
      </p>
    </div>

    <div class="section-title">
      2. Services Offered:
      <p>
        ArogyaLine is a platform that provides internet-based services to facilitate online appointment booking with
        healthcare professionals and service providers (collectively referred to as "Services"). Users can book
        appointments through the Platform. However, it is clarified that ArogyaLine solely facilitates the process of
        booking appointments and does not guarantee or warrant the confirmation, approval, or delivery of any Service.

        All rights to approve, modify, or cancel appointments rest exclusively with the healthcare professionals and the
        ArogyaLine platform. ArogyaLine acts purely as a service provider and assumes no liability for the approval,
        cancellation, or execution of appointments.

        The booking of Services is additionally governed by specific policies, such as cancellation policy, rescheduling
        policy, etc., which are available in the FAQ section of the Platform and are incorporated here by reference.
        Users are responsible for adhering to these policies when making or cancelling appointments.

        Users must confirm (via a cancel appointment button) that their cancellation request complies with the permitted
        cancellation
        window and the Platform's policies. Cancellation requests outside the permitted window will be declined, and
        such appointments will remain confirmed. ArogyaLine assumes no responsibility in this regard.

        Additionally, users who fail to attend their confirmed appointments will not have any recourse. ArogyaLine holds
        no liability for missed appointments or issues related to cancellations arising therefrom.

        These Terms of Use may be further supplemented by specific conditions displayed with individual Services.
      </p>
      <p>
        Disclaimer:

        ArogyaLine does not warrant that the descriptions of Services or other content available on the Platform are
        accurate, complete, reliable, current, or error-free. ArogyaLine assumes no liability in this regard.
      </p>
    </div>

    <div class="section-title">
      3. Platform for Transaction and Communication:
      <p>
        The Users utilize the Platform to meet and interact with one another for their transactions. ArogyaLine is not
        and cannot be a party to or control in any manner any transaction between ArogyaLine's Users. Henceforward:
      </p>
      <ul>
        <li>
          All commercial/contractual terms are offered by and agreed to between Patient & Doctor alone. The
          commercial/contractual terms include, without limitation, consultation fees, service costs, payment methods,
          payment terms, date, period and mode of service delivery, warranties related to services, and after-service
          support. ArogyaLine does not have any control or does not determine or advise or in any way involve itself in
          the offering or acceptance of such commercial/contractual terms between the Patient & Doctor.
        </li>
        <li>
          ArogyaLine does not make any representation or warranty as to the specifics (such as quality, value,
          expertise, etc.) of the services proposed to be offered or provided on the Platform.
        </li>
        <li>
          ArogyaLine is not responsible for any non-performance or breach of any contract entered into between Patients
          and Doctors. ArogyaLine cannot and does not guarantee that the concerned Patients and/or Doctors will perform
          any transaction concluded on the Platform.
        </li>
        <li>
          At no time shall ArogyaLine hold any right, title, or interest over the services nor shall ArogyaLine have any
          obligations or liabilities in respect of such contract entered into between Patient & Doctor.
        </li>
        <li>
          ArogyaLine is only a platform that can be utilized by Users to reach a larger base to avail and provide
          services. ArogyaLine is only providing a platform for communication, and it is agreed that the contract for
          the provision of any of the services shall be a strictly bipartite contract between the Patient and the
          Doctor. At no time shall ArogyaLine hold any right, title, or interest over the services nor shall ArogyaLine
          have any obligations or liabilities in respect of such contract. ArogyaLine is not responsible for
          unsatisfactory or delayed performance of services or damages or delays as a result of issues beyond its
          control.
        </li>
        <li>
          Service pricing as reflected on the Platform may, due to some technical issue, typographical error, or
          information provided by the Doctor, be incorrectly reflected, and in such an event, the Doctor may cancel the
          service appointment(s).
        </li>
        <li>
          You release and indemnify ArogyaLine and/or any of its officers and representatives from any cost, damage,
          liability, or other consequence of any of the actions of the Users of ArogyaLine, and specifically waive any
          claims that you may have in this behalf under any applicable law. Notwithstanding its reasonable efforts in
          that behalf, ArogyaLine cannot take responsibility or control the information provided by other Users which is
          made available on the Platform.
        </li>
      </ul>
    </div>

    <div class="section-title">
      4. User Conduct and Rules on the Platform:
      <p>
        You agree, undertake and confirm that Your use of the Platform shall be strictly governed by the following
        binding
        principles:
      </p>
      <li>
        <span>
          You shall not host, display, upload, modify, publish, transmit, update or share any information which:
        </span>
        <ul>
          <li>
            belongs to another person and to which You do not have any right to
          </li>
          <li>
            is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic, paedophilic, libellous,
            invasive of
            another's privacy, hateful, or racially, ethnically objectionable, disparaging, relating or encouraging
            money
            laundering or gambling, or otherwise unlawful in any manner whatever
          </li>
          <li>
            is misleading in any way
          </li>
          <li>
            involves the transmission of "junk mail", "chain letters", or unsolicited mass mailing or "spamming"
          </li>
          <li>
            promotes illegal activities or conduct that is abusive, threatening, obscene, defamatory or libellous
          </li>
          <li>
            infringes upon or violates any third party's rights including, but not limited to, intellectual property
            rights,
            rights of privacy (including without limitation unauthorized disclosure of a person's name, email address,
            physical
            address or phone number) or rights of publicity
          </li>
          <li>
            contains restricted or password-only access pages, or hidden pages or images (those not linked to or from
            another
            accessible page)
          </li>
          <li>
            provides instructional information about illegal activities such as making or buying illegal weapons,
            violating
            someone's privacy, or providing or creating computer viruses
          </li>
          <li>
            contains video, photographs, or images of another person (with a minor or an adult).
          </li>
          <li>
            tries to gain unauthorized access or exceeds the scope of authorized access to the Platform or to profiles,
            blogs,
            communities, account information, bulletins, friend request, or other areas of the Platform or solicits
            passwords or
            personal identifying information for commercial or unlawful purposes from other users
          </li>
          <li>
            interferes with another USER's use and enjoyment of the Platform or any other individual's User and
            enjoyment of
            similar services
          </li>
          <li>
            infringes any patent, trademark, copyright or other proprietary rights or third party's trade secrets or
            rights of
            publicity or privacy or shall not be fraudulent
          </li>
          <li>
            violates any law for the time being in force
          </li>
          <li>
            threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign
            states,
            or public order or causes incitement to thecommission of any cognizable offence or prevents investigation of
            any
            offence or is insulting any other nation
          </li>
          <li>
            shall not be false, inaccurate or misleading
          </li>
          <li>
            shall not create liability for Us or cause Us to lose (in whole or in part) the services of Our internet
            service
            provider ("ISPs") or other suppliers
          </li>
        </ul>
      </li>
      <li>
        <span>
          A User may be considered fraudulent or loss to business due to fraudulent activity if any of the following
          scenarios
          are met:
        </span>
        <ul>
          <li>
            Users doesn't reply to the payment verification mail sent by ArogyaLine
          </li>
          <li>
            Users fails to produce adequate documents during the payment details verification
          </li>
          <li>
            Misuse of another Users's phone/email
          </li>
          <li>
            Users uses invalid address, email and phone no.
          </li>
          <li>
            Overuse of a voucher code
          </li>
          <li>
            Use of a special voucher not tagged to the email ID used.
          </li>
          <li>
            Miscellaneous activities conducted with the sole intention to cause loss to business/revenue to ArogyaLine
          </li>
        </ul>
      </li>
      <li>
        ArogyaLine does not facilitate business-to-business transactions between medical professionals and business
        customers. The
        Platform solely provides services to facilitate the booking of appointments with healthcare professionals. Users
        are advised to refrain from transacting on the Platform if the intention is to avail of the benefits of input
        tax credit, as ArogyaLine does not handle payment transactions or related tax implications.
      </li>
      <li>
        You shall not use the Platform for any unlawful and fraudulent purposes, which may cause annoyance and
        inconvenience
        and abuses any policy and rules of the company and interrupt or causes to interrupt, damages the use by other
        Users
        of ArogyaLine.
      </li>
      <li>
        You shall not use any false e-mail address, impersonates any person or entity, or otherwise misleads ArogyaLine
        by
        sharing multiple address and phone numbers or transacting with malafide intentions.
      </li>
      <li>
        We on certain landing page even allow our Users to experience free exchange of ideas and observations regarding
        interest in the services, including ‘viewing user generated content’ and/or ‘videos’ and ‘posting
        comments’.
        By accessing, viewing and/or posting any user generated content to any specific dedicated page on the Platform,
        you
        accept and consent to the practices described in these ‘Terms of Service’ and ‘Privacy Policies’, as well as any
        other terms of prescribed by the ArogyaLine on the Platform. You agree and undertake that when accessing,
        viewing
        and/or posting any user generated content on these pages You will not imitate, abuse, harass, any Customer/User
        or
        violate and exploit, any of these ‘Terms of Service’ of the Platform.
      </li>
      <li>
        You shall not use any "deep-link", "page-scrape", "robot", "spider" or other automatic device, program,
        algorithm or
        methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any portion of the
        Platform or any Content, or in any way reproduce or circumvent the navigational structure or presentation of the
        Platform or any Content, to obtain or attempt to obtain any materials, documents or information through any
        means
        not purposely made available through the Platform. We reserve Our right to bar any such activity.
      </li>
      <li>
        You shall not attempt to gain unauthorized access to any portion or feature of the Platform, or any other
        systems or
        networks connected to the Platform or to any server, computer, network, or to any of the services offered on or
        through the Platform, by hacking, password "mining" or any other illegitimate means.
      </li>
      <li>
        You may not pretend that You are, or that You represent, someone else, or impersonate any other individual or
        entity
      </li>
      <li>
        You shall at all times ensure full compliance with the applicable provisions of the Information Technology Act,
        2000, and rules thereunder as applicable and as amended from time to time. You shall also comply with all
        applicable domestic laws, rules, and regulations (including the provisions of any applicable Exchange Control
        Laws or Regulations in force) and international laws, foreign exchange laws, statutes, ordinances, and
        regulations (including, but not limited to, Income Tax, Service Tax, Central Excise, and Local Levies) regarding
        your use of our service and your booking, solicitation of services, and provision of services. You shall not
        engage in any transaction in a service that is prohibited by the provisions of any applicable law, including
        exchange control laws or regulations, for the time being in force.
      </li>
      <li>
        From time to time, you shall be responsible for providing information relating to the services proposed to be
        offered by you. In this connection, you undertake that all such information shall be accurate in all respects.
        You shall not exaggerate or overemphasize the attributes of such services so as to mislead other Users in any
        manner.
      </li>
      <li>
        You shall not engage in advertising to, or solicitation of, other Users of the Platform to buy or sell any
        services, including, but not limited to, services related to that being displayed on the Platform or related to
        ArogyaLine.
      </li>
      <li>
        The content posted does not necessarily reflect ArogyaLine's views. In no event shall ArogyaLine assume or have
        any responsibility or liability for any content posted or for any claims, damages, or losses resulting from the
        use of content and/or the appearance of content on the Platform. You hereby represent and warrant that you have
        all necessary rights in and to all content which you provide and all information it contains, and that such
        content shall not infringe any proprietary or other rights of third parties or contain any libellous, tortious,
        or otherwise unlawful information.
      </li>
      <li>
        AI-generated responses and tags are powered by ChatGPT from OpenAI and Microsoft. While we strive for accuracy,
        there may be instances of inaccurate or insensitive information. Users are encouraged to exercise discretion and
        avoid sharing personal information. Please go through the complete reviews by other users for detailed
        information.
      </li>
      <li>
        ArogyaLine may unilaterally terminate Your account on any event as mentioned in the Terms Of Use under the point
        no.
        4. User Conduct and Rules on the Platform. Any ArogyaLine credits earned as goodwill compensation, earned via
        loyalty or referral program or promotional campaigns or earned through gift cards purchased on other platforms
        will
        be forfeited in such cases.
      </li>
    </div>
    <div class="section-title">
      5. Contents Posted on Platform:
      <p>
        All text, graphics, user interfaces, visual interfaces, photographs, trademarks, logos, sounds, music and
        artwork
        (collectively, "Content"), is a third party user generated content and ArogyaLine has no control over such third
        party user generated content as ArogyaLine is merely an intermediary for the purposes of this Terms of Use. Such
        Content will become Our property and You grant Us the worldwide, perpetual and transferable rights in such
        Content.
        We shall be entitled to, consistent with Our Privacy Policy as adopted in accordance with applicable law, use
        the
        Content or any of its elements for any type of use forever, including but not limited to promotional and
        advertising
        purposes and in any media whether now known or hereafter devised, including the creation of derivative works
        that
        may include the Content You provide.
      </p>
      <p>
        You may use information on the website and services purposely made available on the Platform for downloading,
        provided that You
      </p>
      <ul>
        <li>
          do not remove any proprietary notice language in all copies of such documents,
        </li>
        <li>
          use such information only for your personal, non-commercial informational purpose and do not copy or post such
          information on any networked computer or broadcast it in any media,
        </li>
        <li>
          make no modifications to any such information, and
        </li>
        <li>
          do not make any additional representations or warranties relating to such documents,
        </li>
      </ul>
    </div>
    <div class="section-title">
      6. Disclaimer of Warranties and Liability:
      <p>
        All the materials and services included on or otherwise made available to you through the Platform are provided
        on an "as is" and "as available" basis without any representation or warranties, express or implied except
        otherwise specified in writing. Without prejudice to the foregoing paragraph, ArogyaLine does not warrant that
        the Platform will be constantly available, or available at all, or that the information on the Platform is
        complete, true, accurate, or non-misleading.
      </p>
      <p>
        You will be
        required to enter a valid phone number while booking an appointment on the Platform. By registering your phone
        number with us, you consent to be contacted by us via phone calls and/or SMS notifications, in case of any
        appointment-related updates. We will not use your personal information to initiate any promotional phone calls
        or SMS.
      </p>
    </div>
    <div class="section-title">
      7. Payment
      <p>
        While availing any of the payment methods available on the Platform, we will not be responsible or assume any
        liability whatsoever in respect of any loss or damage arising directly or indirectly to you due to:
      </p>
      <ul>
        <li>
          Lack of authorization for any transaction(s), or
        </li>
        <li>
          Exceeding the preset limit mutually agreed by you and between 'Bank(s)', or
        </li>
        <li>
          Any payment issues arising out of the transaction, or
        </li>
        <li>
          Decline of transaction for any other reason(s)
          <p>
            All payments made against the bookings/services on the Platform by you shall be compulsorily in Indian
            Rupees acceptable in the Republic of India. The Platform will not facilitate transactions with respect to
            any other form of currency for the bookings made on the Platform.
          </p>
          <p>
            Before confirming your appointment, the healthcare provider may request you to provide supporting documents
            (including but not limited to government-issued ID and address proof) to establish the ownership of the
            payment instrument used by you for your booking. This is done in the interest of providing a safe online
            booking environment to our Users.
          </p>
          <p>
            Further:
          </p>
        </li>
        <li>
          Transactions, Transaction Price, and all commercial terms such as delivery of services are as per
          principal-to-principal bipartite contractual obligations between Patient and Doctor, and the payment facility
          is merely used by the Patient and Doctor to facilitate the completion of the Transaction. Use of the payment
          facility shall not render ArogyaLine liable or responsible for the non-delivery, non-receipt, non-payment,
          damage, breach of representations and warranties, non-provision of after-sales or warranty services, or fraud
          as regards the services listed on ArogyaLine's Platform.
        </li>
        <li>
          You have specifically authorized ArogyaLine or its service providers to collect, process, facilitate, and
          remit payments and/or the Transaction Price electronically
          in respect of transactions through the Payment Facility. Your relationship with ArogyaLine is on a
          principal-to-principal basis, and by accepting these Terms of Use, you agree that ArogyaLine is an independent
          contractor for all purposes, and does not have control of or liability for the services that are listed on
          ArogyaLine's Platform that are paid for by using the Payment Facility. ArogyaLine does not guarantee the
          identity of any User nor does it ensure that a Patient or a Doctor will complete a transaction.
        </li>
        <li>
          You understand, accept, and agree that the payment facility provided by ArogyaLine is neither a banking nor
          financial service but is merely a facilitator providing an electronic, automated online electronic payment,
          receiving payment through collection, and remittance facility for the Transactions on the
          ArogyaLine Platform using the existing authorized banking infrastructure and credit card payment gateway
          networks. Further, by providing the Payment Facility, ArogyaLine is neither acting as a trustee nor acting in
          a fiduciary capacity with respect to the Transaction or the Transaction Price.
        </li>
        <li>
          <strong>
            ArogyaLine will not provide any refund once a service subscription is purchased. Users are
            advised to
            carefully review the service details before completing their transaction.
          </strong>
        </li>
        <li>
          ArogyaLine reserves the right to impose limits on the number of transactions or transaction prices that it may
          process for an individual User during any given period and reserves the right to refuse to process
          transactions exceeding such limits. ArogyaLine also reserves the right to refuse transactions by Users with a
          prior history of questionable activity, including but not limited to breaches of agreements, violation of
          policies, or any legal infringements.
        </li>
        <li>
          In the event of suspicious transactions or unusually high transaction volumes, ArogyaLine may delay notifying
          payment confirmations or informing the healthcare professional to confirm the appointment. ArogyaLine may also
          hold the transaction price and, at the request of law enforcement authorities, not remit the transaction price
          to the healthcare professional or user if illegal activity is suspected.
        </li>
        <li>
          The user and the healthcare professional acknowledge that ArogyaLine will not be liable for any damages,
          interests, or claims resulting from not processing a transaction/transaction price or any delay in processing
          a transaction/transaction price which is beyond the control of ArogyaLine.

          Compliance with Laws:
        </li>
        <p>
          Users and healthcare professionals shall comply with all the applicable laws (including without limitation
          Foreign Exchange Management Act, 1999 and the rules made and notifications issued thereunder and the Exchange
          Control Manual as may be issued by the Reserve Bank of India from time to time, Customs Act, Information
          Technology Act, 2000 as amended by the Information Technology (Amendment) Act 2008, Prevention of Money
          Laundering Act, 2002 and the rules made thereunder, Foreign Contribution Regulation Act, 1976 and the rules
          made thereunder, Income Tax Act, 1961 and the rules made thereunder, Export-Import Policy of the government of
          India) applicable to them respectively for using the payment facility and ArogyaLine Platform.

          <br>User's arrangement with Issuing Bank:
        </p>
        <li>
          All valid credit/debit/cash cards and other payment instruments are processed using appropriate payment
          systems authorized by the respective issuing banks. Such transactions are governed by the terms and conditions
          agreed upon between the User and the issuing bank or payment instrument company.
        </li>
      </ul>
    </div>
    <div class="section-title">
      8. E-Platform for Communication:
      <p>
        You agree, understand, and acknowledge that ArogyaLine is an online platform that enables you to book
        appointments with healthcare professionals listed on the Platform at the price indicated therein at any time.
        You further agree and acknowledge that ArogyaLine is only a facilitator and is not and cannot be a party to or
        control in any manner any transactions on ArogyaLine.
      </p>
    </div>
    <div class="section-title">
      9. Indemnity:
      <p>
        You shall indemnify and hold harmless ArogyaLine, its owner, licensee, affiliates, subsidiaries, group companies
        (as
        applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or
        actions
        including reasonable attorneys' fees, made by any third party or penalty imposed due to or arising out of Your
        breach of this Terms of Use, privacy Policy and other Policies, or Your violation of any law, rules or
        regulations
        or the rights (including infringement of intellectual property rights) of a third party.
      </p>
    </div>
    <div class="section-title">
      10. Trademark, Copyright and Restriction:
      <p>
        The Platform is controlled and operated by ArogyaLine, and services are provided by respective healthcare
        professionals. All material on the Platform, including images, illustrations, audio clips, and video clips, are
        protected by copyrights, trademarks, and other intellectual property rights. Material on ArogyaLine is solely
        for your personal, non-commercial use. You must not copy, reproduce, republish, upload, post, transmit or
        distribute such material in any way, including by email or other electronic means, and whether directly or
        indirectly, and you must not assist any other person to do so. Without the prior written consent of the owner,
        modification of the materials, use of the materials on any other platform or networked computer environment, or
        use of the materials for any purpose other than personal, non-commercial use is a violation of the copyrights,
        trademarks, and other proprietary rights and is prohibited. Any use for which you receive any remuneration,
        whether in money or otherwise, is a commercial use for the purposes of this clause.

        It is expressly clarified that you will retain ownership and shall solely be responsible for any content that
        you provide or upload when using any service, including any text, data, information, images, photographs, music,
        sound, video, or any other material which you may upload, transmit, or store when making use of our various
        services. However, we reserve the right to use/reproduce any content uploaded by you, and you agree to grant
        royalty-free, irrevocable, unconditional, perpetual, and worldwide rights to us to use the content for
        reasonable business purposes.
      </p>
    </div>
    <div class="section-title">
      11. Limitation of Liability:
      <p>
        In no event shall ArogyaLine be liable for any indirect, punitive, incidental, special, consequential damages,
        or any other damages resulting from:
      </p>
      <ul>
        <li>
          The use or the inability to use the Services
        </li>
        <li>
          Unauthorized access to or alteration of the user's transmissions or data
        </li>
        <li>
          Breach of condition, representations, or warranties by the healthcare professionals
        </li>
        <li>
          Any other matter relating to the services including, without limitation, damages for loss of use, data, or
          profits, arising out of or in any way connected with the use or performance of the Platform or Service.
        </li>
      </ul>
      <p>
        ArogyaLine shall not be held responsible for non-availability of the ArogyaLine Platform during periodic
        maintenance operations or any unplanned suspension of access to ArogyaLine. The User understands and agrees
        that any material and/or data downloaded from ArogyaLine is done entirely at the User's own discretion and
        risk, and they will be solely responsible for any damage to their mobile or loss of data that results from the
        download of such material and/or data.

        To the maximum extent permissible under law, ArogyaLine’s liability shall be limited to an amount equal to the
        value of the services booked by you. ArogyaLine shall not be liable for any dispute or disagreement between
        Users.
      </p>
    </div>
    <div class="section-title">
      12. Termination:
      <p>
        ArogyaLine may suspend or terminate your use of the ArogyaLine Platform or any service if it believes, in its
        sole and absolute discretion, that you have infringed, breached, violated, abused, or unethically manipulated or
        exploited any term of these Terms of Service or otherwise acted unethically. Notwithstanding anything in this
        clause, these Terms of Service will survive indefinitely unless and until ArogyaLine chooses to terminate them.
      </p>
      <ul>
        <li>
          If you or ArogyaLine terminates your use of the Platform or any service, ArogyaLine may delete any content or
          other materials relating to your use of the service, and ArogyaLine will have no liability to you or any third
          party for doing so. However, your transaction details may be preserved by ArogyaLine for purposes of tax or
          regulatory compliance.
        </li>
        <li>
          ArogyaLine may unilaterally terminate your account on any event as mentioned in the Terms of Use under the
          point no. 4, User Conduct and Rules on the Platform. Any ArogyaLine credits earned as goodwill compensation,
          earned via loyalty or referral programs or promotional campaigns, or earned through gift cards purchased on
          other platforms, will be forfeited in such cases. Returns/refunds for such Users shall be at the sole
          discretion of ArogyaLine.
        </li>
        <li>
          If you use any false email address or use the Platform for any unlawful and fraudulent purposes, which may
          cause annoyance and inconvenience and abuses any policy and rules of the company or mislead ArogyaLine by
          sharing multiple addresses and phone numbers or transacting with malafide intentions, then ArogyaLine reserves
          the right to refuse access to the Platform, terminate accounts including any linked accounts without notice to
          you.
        </li>
      </ul>
    </div>
    <div class="section-title">
      13. Jurisdictional Issues:
      <p>
        Unless otherwise specified, the material on the Platform is presented solely for the purpose of booking
        appointments in India. ArogyaLine makes no representation that materials on the Platform are appropriate or
        available for use in other locations/countries outside India. Those who choose to access the Platform from other
        locations/countries outside India do so on their own initiative, and ArogyaLine is not responsible for the
        availability of services or refunds for services booked from other locations/countries outside India, or
        compliance with local laws, if and to the extent local laws are applicable.
      </p>
    </div>
    <div class="section-title">
      14. Governing Law:
      <p>
        These terms shall be governed by and constructed in accordance with the laws of India without reference to
        conflict
        of laws principles and disputes arising in relation hereto shall be subject to the exclusive jurisdiction of
        courts,
        tribunals, fora, applicable authorities at Pune. The place of jurisdiction shall be exclusively in
        Pune.
      </p>
    </div>
    <div class="section-title">
      15. Disclaimer:
      <p>
        You acknowledge and undertake that you are accessing the services on the Platform and transacting at your own
        risk and are using your best and prudent judgment before entering into any transactions through ArogyaLine. We
        shall neither be liable nor responsible for any actions or inactions of healthcare professionals nor any breach
        of conditions, representations, or warranties by the healthcare professionals and hereby expressly disclaim any
        and all responsibility and liability in that regard. We shall not mediate or resolve any dispute or disagreement
        between you and the healthcare professionals. We further expressly disclaim any warranties or representations
        (express or implied) in respect of quality, suitability, accuracy, reliability, completeness, timeliness,
        performance, safety, merchantability, fitness for a particular purpose, or legality of the services listed or
        displayed or transacted or the content (including service or pricing information and/or specifications) on the
        Platform. While we have taken precautions to avoid inaccuracies in content, this website, all content,
        information (including the price of services), software, products, services and related graphics are provided as
        is, without warranty of any kind. At no time shall any right, title, or interest in the services booked through
        or displayed on the Platform vest with ArogyaLine, nor shall ArogyaLine have any obligations or liabilities in
        respect of any transactions on the Platform.
      </p>
      <p>
        Appointment Related - User agrees and acknowledges that any claims regarding appointment booking (including
        non-receipt/non-confirmation of appointment) shall be notified to ArogyaLine within 5 days from the alleged date
        of appointment reflecting on the ArogyaLine portal. Non-notification by you of non-receipt or non-confirmation
        within the time period specified shall be construed as a deemed confirmation in respect of that transaction.
        ArogyaLine disclaims any liability or responsibility for claims regarding non-confirmation or non-receipt of
        appointment after 5 days from the alleged date of appointment reflecting on the ArogyaLine portal.
      </p>
    </div>
    <div class="section-title">
      16. Grievance
      <p>
        In accordance with Information Technology Act 2000 and rules made there under and the Consumer Protection
        (E-Commerce) Rules, 2020, the name and contact details of the Grievance are provided below:
      </p>
      <p>
        Mrs. Roshani Bendre
      </p>
      <p>
        ArogyaLine,
      </p>
      <p>
        Shivani Building, Sanjay Park, Lane number 6, Airport Road, Pune, Maharashtra : 411032, India
      </p>
      <p>
        <a href="mailto:support@ArogyaLine.com">support&#64;ArogyaLine.com</a>
      </p>
      <p>
        Phone: <a href="tel:918390857034">+918390857034</a>
      </p>
      <p>
        Time: Mon - Fri(9:00 - 18:00)
      </p>
      <p>
        Customer Support: You can reach our customer support team to address any of your queries or complaints by
        clicking
        the link: <a href="https://www.ArogyaLine.com/contactus">Contact Us</a>
      </p>
    </div>
  </div>
</div>
